export class ShebaMilesAccountLogin {
  userName = null;
  password = null;
  isUserNameValid = true;
  isPasswordValid = true;
}
